<script>
import Spinner from "@/components/ui/Spinner";
import patientService from "@/services/patient";

export default {
  name: "ModalDownloadPdf",

  components: { Spinner },

  props: {
    visible: { type: Boolean, required: true },
    patientId: { type: String, default: null },
    patientName: { type: String, default: "" },
  },

  data() {
    return {
      dateRange: null,
      isDownloading: false,
    };
  },

  watch: {
    visible(value) {
      if (!value) {
        this.dateRange = null;
      }
    },
  },

  methods: {
    close() {
      if (this.isDownloading) return;
      this.$emit("update:visible", false);
    },

    async download() {
      this.isDownloading = true;
      try {
        const [from, to] = this.dateRange || [];
        const response = await patientService.generatePDF(this.patientId, {
          from,
          to,
        });

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        const fileName = (this.patientName || this.patientId || "paciente")
          .replace(/[, ]+/g, "-")
          .toLowerCase();
        link.download = `historia-clinica-${fileName}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$message.success("PDF descargado correctamente");
        this.close();
      } catch (error) {
        console.error("Error al descargar PDF:", error);

        let errorMessage =
          "Error al descargar el PDF. Por favor, intente nuevamente.";

        if (error.response?.data instanceof Blob) {
          try {
            const text = await new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onload = () => resolve(reader.result);
              reader.onerror = reject;
              reader.readAsText(error.response.data);
            });
            const errorData = JSON.parse(text);
            errorMessage = errorData.error || errorMessage;
          } catch (parseError) {
            console.warn(
              "No se pudo parsear el error del servidor:",
              parseError
            );
          }
        } else if (error.message) {
          errorMessage = error.message;
        }

        this.$message.error(errorMessage);
      } finally {
        this.isDownloading = false;
      }
    },
  },
};
</script>

<template lang="pug">
  el-dialog.modal-download-pdf(
    :visible="visible"
    :before-close="close"
    title="Descargar historia clínica"
    width="480px"
  )
    p.modal-patient-name(v-if="patientName") {{ patientName }}
    p.modal-hint Seleccioná un rango de fechas para filtrar la historia clínica a descargar, o dejalo vacío para incluir todo el historial.

    el-date-picker.modal-date-picker(
      v-model="dateRange"
      type="daterange"
      range-separator="-"
      start-placeholder="Desde"
      end-placeholder="Hasta"
      value-format="yyyy-MM-dd"
      :clearable="true"
      :disabled="isDownloading"
    )

    .el-dialog__footer
      el-button(@click="close" :disabled="isDownloading") Cancelar
      el-button(type="primary" :loading="isDownloading" @click="download") Descargar PDF
</template>

<style lang="scss" scoped>
.modal-patient-name {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 8px;
  color: #405186;
}

.modal-hint {
  font-size: 13px;
  color: #666;
  margin-bottom: 16px;
  word-break: normal;
}

.modal-date-picker {
  width: 100%;
}

.el-dialog__footer {
  margin-top: 20px;
  text-align: right;
}
</style>
